import axios from 'axios';

import { throwError } from '../../../modules/error';

export interface NewsType {
  category: string;
  content: string;
  id: string;
  publishedAt: string;
  title: string;
}

export const getNewsList = async (): Promise<NewsType[]> => {
  try {
    const url = `https://${
      process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
    }.microcms.io/api/v1/news`;
    const res = await axios.get<{ contents: NewsType[] }>(url, {
      headers: {
        'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY ?? ''
      }
    });
    return res.data.contents;
  } catch (e) {
    throwError(e);
    return [];
  }
};

export const getNews = async (id: string): Promise<NewsType> => {
  try {
    const url = `https://${
      process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
    }.microcms.io/api/v1/news/${id}`;
    const res = await axios.get<NewsType>(url, {
      headers: {
        'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY ?? ''
      }
    });
    return res.data;
  } catch (e) {
    throwError(e);
    return {
      category: '',
      content: '',
      id: '',
      publishedAt: '',
      title: ''
    };
  }
};
